import { render, staticRenderFns } from "./Confirma.vue?vue&type=template&id=454f90dc"
import script from "./Confirma.vue?vue&type=script&lang=js"
export * from "./Confirma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports